import { TreeModule } from '@ali-hm/angular-tree-component';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  DefaultUrlSerializer,
  RouterModule,
  UrlSerializer,
  UrlTree,
} from '@angular/router';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { NgxPaginationModule } from 'ngx-pagination';
import { AccountProfileComponent } from './accountProfile/accountProfile.component';
import { AccountProfileService } from './accountProfile/accountProfile.service';
import { AccountProfileEditComponent } from './accountProfile/accountProfileEdit/accountProfileEdit.component';
import { AddtositeComponent } from './addtosite/addtosite.component';
import { AddtositeService } from './addtosite/addtosite.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BroadcastHistoryComponent } from './broadcast-history/broadcast-history.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProgressBarModule } from 'primeng/progressbar';
import { DatePickerModule } from 'primeng/datepicker';
import { ChangePasswordComponent } from './changePassword/changePassword.component';
import { RsaService } from './common_services/encryptutil.service';
import { FieldValidateService } from './common_services/fieldvalidate.service';
import { DocumentsService } from './documents/documents.service';
import { KeysPipe } from './documents/key-value.pipe';
import { FooterConnectComponent } from './footer/connect/connect.component';
import { FooterFaqComponent } from './footer/faq/faq.component';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { ForgotpasswordService } from './forgotpassword/forgotpassword.service';
import { ForgotpasswordquestionsComponent } from './forgotpasswordquestions/forgotpasswordquestions.component';
import { ForgotpasswordquestionsService } from './forgotpasswordquestions/forgotpasswordquestions.service';
import { ForgotusernameComponent } from './forgotusername/forgotusername.component';
import { FrontdeskComponent } from './frontdesk/frontdesk.component';
import { HeaderService } from './header/header.service';
import { HomeComponent } from './home/home.component';
import { InboxComponent } from './inbox/inbox.component';
import { MaterialModule } from './material.module';
import { PatientSurveyResultService } from "./providerportal/patient-survey-result/patient-survey-result.service";

import {MatCardModule} from '@angular/material/card';

// import {RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { ResetpasswordService } from "./resetpassword/resetpassword.service";
import { providerDataUpdateService } from "./providerportal/provider-data-update/provider-data-update.service";
import { ProviderOutreachService } from "./providerportal/provider-outreach/provider-outreach.service";

import { ClaimnavigationService } from './providerportal/claimsummary/claimnavigation.service';
import { PdfService } from './providerportal/epahaf/epahaf-pdf.service';
import { EpahafService } from './providerportal/epahaf/epahaf.service';
import { PcpScorecardService } from './providerportal/pcp-scorecard/pcp-scorecard.service';
import { TrainingMaterialService } from './providerportal/provider-training/trainingmaterial.service';
import { ProviderportalService } from './providerportal/providerportal.service';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { SecureStorageService } from './secure-storage.service';
import { AlertServiceService } from './shared/services/alert-service.service';
import { ConfigProvider } from './shared/services/configprovider';
import { CupService } from './shared/services/cup.service';
import { GlobalService } from './shared/services/global.service';
import { UrlconstantsService } from './shared/services/urlconstants.service';
import { SharedModules } from './shared/shared.module';
import { SigninComponent } from './signin/signin.component';
import { SignupConfirmationComponent } from './signup-form/confirmation/confirmation.component';
import { SignupFormComponent } from './signup-form/signup-form.component';
import { SignupFormService } from './signup-form/signup-form.service';
import { TruncatePipe } from './truncate.pipe';
import { UploaddocumentComponent } from './uploaddocument/uploaddocument.component';
import { UploaddocumentService } from './uploaddocument/uploaddocument.service';
import { UserauthenticationComponent } from './userauthentication/userauthentication.component';
import { ValidatedocumentComponent } from './validatedocument/validatedocument.component';
import { ValidatedocumentService } from './validatedocument/validatedocument.service';
import { MfaComponent } from "./mfa/mfa.component";
import { MfaOtpVerifyComponent } from "./mfa/mfa-otp-verify/mfa-otp-verify.component";
import { SignupOtpVerifyComponent } from "./signup-form/signup-otp-verify/signup-otp-verify.component";

import { CommonModule,DatePipe } from '@angular/common';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { FileUploadModule } from 'ng2-file-upload';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { NgxLoadingModule } from 'ngx-loading';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { DocumentsComponent } from './documents/documents.component';
import { ProviderModule } from './providerportal/providermodule.module';
import { CupDateService } from './shared/services/cup-date.service';
import { PreferencesService } from './shared/services/preferences.service';
import { UserIdleModule } from 'angular-user-idle';
import { PqvDashboardService } from './providerportal/pqvdashboard/services/pqvDashboard.services';
// import { ToastrModule } from 'ngx-toastr';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import Lara from '@primeuix/themes/lara'
export class CustomUrlSerializer implements UrlSerializer {
  private _defaultUrlSerializer: DefaultUrlSerializer =
    new DefaultUrlSerializer();

  parse(url: string): UrlTree {
    // Encode "+" to "%2B"
    url = url.replace(/\+/gi, '%2B');
    // Use the default serializer.
    return this._defaultUrlSerializer.parse(url);
  }

  serialize(tree: UrlTree): string {
    return this._defaultUrlSerializer.serialize(tree).replace(/\+/gi, '%2B');
  }
}

export function configProviderFactory(provider: ConfigProvider) {
  return () => provider.load();
}

export function setAccessTokenFactory(globalService: GlobalService) {
  return () => globalService.setAccesToken();
}

@NgModule({
  declarations: [
    AppComponent,
    ForgotpasswordComponent,
    ForgotusernameComponent,
    ForgotpasswordquestionsComponent,
    SignupConfirmationComponent,
    // FooterComponent,
    FooterFaqComponent,
    FooterConnectComponent,
    ResetpasswordComponent,
    SigninComponent,
    AccountProfileComponent,
    AccountProfileEditComponent,
    ChangePasswordComponent,
    HomeComponent,
    SignupFormComponent,
    KeysPipe,
    InboxComponent,
    BroadcastHistoryComponent,
    FrontdeskComponent,
    AddtositeComponent,
    UserauthenticationComponent,
    TruncatePipe,
    UploaddocumentComponent,
    ValidatedocumentComponent,
    DocumentsComponent,
    // SinglesignonComponent,
    //MemberSearchFilterPipe
    // FilterArrayPipe
    //RegistrationComponent
    MfaComponent,
    MfaOtpVerifyComponent,
    SignupOtpVerifyComponent
  ],
  exports: [MaterialModule],
  bootstrap: [AppComponent],
  imports: [
    CommonModule,
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    // ToastrModule.forRoot({
    //   positionClass: 'toast-top-center'
    // }),
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    SharedModules,
    NgxLoadingModule,

    NgxPaginationModule,
    FileUploadModule,
    AccordionModule,
    TabsModule,
    TooltipModule,
    TreeModule,
    // PopoverModule.forRoot(),
    // TreeModule.forRoot(),
    // // AuthMessagesModule,
    // SortableModule.forRoot(),
    // // ProviderModule,
    DialogModule,
    TypeaheadModule,
    ProgressBarModule,
    MaterialModule,
    MatCardModule,
    SharedModules,
    AngularMultiSelectModule,
    DatePickerModule,
    ProviderModule,
    UserIdleModule.forRoot({ idle: 28800, timeout: 61, ping: 61 }),
    AppRoutingModule,
  ],
  providers: [
    ConfigProvider,
    { provide: UrlSerializer, useClass: CustomUrlSerializer },
    provideAppInitializer(() => {
        const initializerFn = (configProviderFactory)(inject(ConfigProvider));
        return initializerFn();
      }),
    provideAppInitializer(() => {
        const initializerFn = (setAccessTokenFactory)(inject(GlobalService));
        return initializerFn();
      }),
      providePrimeNG({
        theme: {
            preset: Lara,
            options: {
              darkModeSelector: false 
            }

        }
    }),
    //     mockBackendProvider,
    //     MockBackend,
    // BaseRequestOptions,
    FieldValidateService,
    DocumentsService,
    HeaderService,
    SignupFormService,
    ProviderportalService,
    ForgotpasswordService,
    AccountProfileService,
    CupService,
    GlobalService,
    UrlconstantsService,
    RsaService,
    AddtositeService,
    UploaddocumentService,
    ValidatedocumentService,
    ClaimnavigationService,
    EpahafService,
    AlertServiceService,
    PdfService,
    PcpScorecardService,
    TrainingMaterialService,
    SecureStorageService,
    PatientSurveyResultService,
    providerDataUpdateService,
    ProviderOutreachService,
    ForgotpasswordquestionsService,
    ResetpasswordService,
    providerDataUpdateService,
    ProviderOutreachService,
    PreferencesService,
    CupDateService,
    PqvDashboardService,
    DatePipe,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
